<template>
  <button
    v-if="isMobile && cartItemCount > 0"
    class="fixed z-50 bottom-4 right-4 rounded-full shadow-lg bg-[var(--header-color)] text-white w-14 h-14 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-white/70"
    @click="$root.$emit('open-cart')"
    aria-label="Open cart"
    data-testid="floating-cart-button"
  >
    <span class="sr-only">Open cart</span>
    🛒
  </button>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FloatingCartButton',
  data() {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
    }
  },
  computed: {
    ...mapGetters(['cartItemCount']),
    isMobile() {
      return this.windowWidth < 768
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', this.handleResize)
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style scoped>
/* Slight bounce to draw attention */
button { transition: transform 0.2s ease; }
button:active { transform: scale(0.96); }
</style>
